// TYPES
import type { FailedResponse, SuccessResponse } from '..'
import { Address } from '@stripe/stripe-js'

// UTILITIES
import { generateHeaders, createResponseObj } from '..'
import { vcBaseUrl } from '.'


type AddBillingAddressResponse = SuccessResponse | FailedResponse

export class AddBillingAddressRequest extends Request {
    private constructor(userId: string, address: Address, init?: RequestInit) {super(`${vcBaseUrl}/user/${userId}/billing-address`, init)}
    static async init(userId: string, address: Address, init?: RequestInit) {
        return new AddBillingAddressRequest(userId, address, {
            ...init,
            method: 'PUT',
            headers: await generateHeaders("Clerk-Token", init?.headers),
            body: JSON.stringify(address)
        })
    }

    static async fetch(...args: Parameters<typeof this.init>) {
        const request = await this.init(...args)
        return await request.fetch()
    }

    public async fetch(): Promise<void> {
        const response = await fetch(this)
        const data = createResponseObj<AddBillingAddressResponse>(await response.json())
        console.info("Add Billing Address:", data)

        switch (data.status) {
            case 'successful': return
            case 'failed': throw data
            default: throw new Error(`Unsupported Status: ${data}`)
        }
    }
}